/**
 * Donkere weergave (oprichter 1 okt 2026): de ouderapp volgt de systeeminstelling van het
 * apparaat. Bij prefers-color-scheme: dark komt `data-theme="dark"` op <html>, zodat alle tokens
 * (ui-core/tokens.css, het avondthema) meeschakelen. Zonder eigen donkere weergave maakten Chrome en
 * Samsung Internet de lichte app zelf donker, met lichte knoppen en lichte tekst als gevolg.
 * Geeft een opruimfunctie terug.
 */
export function installColorScheme(
  root: HTMLElement = document.documentElement,
  media: MediaQueryList | null = typeof matchMedia === 'function'
    ? matchMedia('(prefers-color-scheme: dark)')
    : null,
): () => void {
  if (!media) return () => undefined;
  const apply = (): void => {
    if (media.matches) root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
  };
  apply();
  media.addEventListener('change', apply);
  return () => media.removeEventListener('change', apply);
}
